import React from 'react';
import { useSelector } from 'react-redux';
import { isCustomerServiceRoleSelector } from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';

// extend to add additional role checks in futre
function useCanAccessFeature({ feature = '' }) {
  const isCustomerServiceRole = useSelector(isCustomerServiceRoleSelector);

  if (
    isCustomerServiceRole &&
    ![featureNames.VIEWER_MODULE_PULSE5, featureNames.VIEWER_DRILLDOWN_TIMELINE].includes(feature)
  ) {
    return false;
  }

  return true;
}

export default useCanAccessFeature;
